import * as React from 'react';
import { Layout, Row, Col, Card } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { assetTypesRestCrudThunksForSupplier } from '../../thunks/asset_types_thunks';
import { TwoLineList } from '../two_line_list/TwoLineList';
import { assetModelsRestCrudThunksForSupplier } from '../../thunks/asset_models_thunks';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';

const { Content } = Layout;

const style = require('./SupplierAssetModelsDetailDetailsPage.less');
const ASSET_MODELS_FOR_TYPES = 'ASSET_MODELS_FOR_TYPES';

interface SupplierAssetModelsDetailPageProps {
	match: any;
}

class SupplierAssetModelsDetailPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			assetModelModalFormVisible: true,
			assetModelFormData: {},
		};
	}

	componentDidMount() {
		const {
			getAssetModel,

			match,
		} = this.props;
		const assetModelId = match.params.id;
		getAssetModel(assetModelId);
	}

	render() {
		const { assetModel, assetModelsFetching, match } = this.props;

		return assetModelsFetching ? (
			<PageLoadingPlaceholder />
		) : (
			<Content className="supplierAssetModelsDetailDetailsPage">
				<LogOnMountWithStandardEventProperties eventType="visited supplier asset model detail page" />
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}
				<Row style={{ margin: '-0.5em -8px 0.5em -8px' }} gutter={16}>
					<Col span={24}>
						<Row style={{ margin: '0.5em -8px' }} gutter={16}>
							<Col span={24}>
								<Card>
									<div className="supplierAssetModelsDetailDetailsPage__listSection">
										<div className="supplierAssetModelsDetailDetailsPage__listSectionTitle">
											Required Fields
										</div>
										{assetModel.specs && assetModel.specs.length === 0 ? (
											'No specs available'
										) : (
											<TwoLineList
												listItems={assetModel.specs}
												lineOneRender={(record) => record.key}
												lineTwoRender={(record) => record.value}
											/>
										)}
									</div>
								</Card>
							</Col>
						</Row>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	assetModelsFetching: state.asset_models.fetching,
	assetModel: state.asset_models.detail,
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch) => ({
	getAssetType: (id) => dispatch(assetTypesRestCrudThunksForSupplier.readOne(id)),
	deleteAssetModel: (entity) => dispatch(assetModelsRestCrudThunksForSupplier.delete(entity)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(SupplierAssetModelsDetailPage)
);
